import { DefaultValue, atom, selector, selectorFamily } from 'recoil';
import { Client } from '../types/client';
import { CurrentState, CurrentStateAction } from '../types/currentState';
import { persistedAtom } from '../utils/persistence';

export const activeClientState = persistedAtom<Client | undefined>('app.activeClient', undefined);

export const currentStatesState = atom<CurrentState[] | undefined>({
  key: 'app.client.currentStates',
  default: undefined,
});

export const currentStateIdsState = selector<string[] | undefined>({
  key: 'app.client.currentStateIds',
  get: ({ get }) => {
    const currentStates = get(currentStatesState);
    if (!currentStates) return;
    return currentStates.map((currentState) => currentState.ident);
  },
});

export const currentStateState = selectorFamily<CurrentState | undefined, string>({
  key: 'app.client.currentState',
  get:
    (ident) =>
    ({ get }) => {
      const currentStates = get(currentStatesState);
      if (!currentStates) return;
      return currentStates.find((currentState) => currentState.ident === ident);
    },
  set:
    (ident) =>
    ({ get, set }, newValue) => {
      if (!newValue || newValue instanceof DefaultValue) return;
      const currentStates = get(currentStatesState);
      if (!currentStates) return;
      const currentStateIndex = currentStates.findIndex((currentState) => currentState.ident === ident);
      if (currentStateIndex === -1) return;
      const newCurrentStates = [...currentStates];
      newCurrentStates[currentStateIndex] = newValue;
      set(currentStatesState, newCurrentStates);
    },
});

export const updatedCurrentStateState = atom<CurrentState | undefined>({
  key: 'app.client.currentState.updated',
  default: undefined,
});

export const updateCurrentStatesState = atom<number>({
  key: 'app.client.currentStates.update',
  default: 0,
});

export const selectedCurrentStateActionState = atom<{ ident: string; name: CurrentStateAction } | undefined>({
  key: 'app.client.currentState.action.selected',
  default: undefined,
});
